var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4163 32.0835V23.3335H49.583V32.0835H40.833V37.9168H49.583V46.6668H55.4163V37.9168H64.1663V32.0835M32.083 37.9168V14.5835C32.083 9.74183 28.1747 5.8335 23.333 5.8335C18.4913 5.8335 14.583 9.74183 14.583 14.5835V37.9168C8.13718 42.7585 6.82468 51.8877 11.6663 58.3335C16.508 64.7793 25.6372 66.0918 32.083 61.2502C38.5288 56.4085 39.8413 47.2793 34.9997 40.8335C34.1801 39.7197 33.1968 38.7364 32.083 37.9168ZM23.333 11.6668C24.9372 11.6668 26.2497 12.9793 26.2497 14.5835V23.3335H20.4163V14.5835C20.4163 12.9793 21.7288 11.6668 23.333 11.6668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureAdd);
export default __webpack_public_path__ + "static/media/temperature-add.56e1db4dac95de561d18282dab64c7ef.svg";
export { ForwardRef as ReactComponent };